<mat-progress-bar
  class="custom-progress-bar"
  mode="indeterminate"
></mat-progress-bar>
